// extracted by mini-css-extract-plugin
export default {"container":"RecentSearchItem_container__3WM3L","type":"RecentSearchItem_type__bx+e1"};